import { DragDropChangeValue, If } from "components";
import { moveElementInArray } from "helpers";
import { useBoolean } from "hooks";
import {
  CreateOfferModal,
  DeleteOfferModal,
  IOffer,
  OfferDetailsModal,
  useOffer,
  useOffersColumns,
  useOffersReorder
} from "modules/offers";
import { useState } from "react";
import { ItemsTableDragDrop } from "ui";

import { OffersTableProps } from "./OffersTable.types";

import styles from "./OffersTable.module.scss";

const OffersTable = ({
  offersList,
  sorting,
  setSorting,
  isLoading,
  isDragDisabled,
  setOffers
}: OffersTableProps) => {
  const [offerId, setOfferId] = useState<string | undefined>(undefined);

  const { offer, isLoading: isLoadingOffer } = useOffer(offerId);

  const offersReorder = useOffersReorder();

  const {
    value: isOpenOfferModal,
    setTrue: onOpenOfferModal,
    setFalse: onCloseOfferModal
  } = useBoolean();

  const {
    value: isOpenOfferDetailsModal,
    setTrue: onOpenOfferDetailsModal,
    setFalse: onCloseOfferDetailsModal
  } = useBoolean();

  const {
    value: isOpenDeleteModal,
    setTrue: onOpenDeleteModal,
    setFalse: onCloseDeleteModal
  } = useBoolean();

  const { columns } = useOffersColumns({
    isDragDisabled,
    onOpenEdit: onOpenOfferModal,
    onOpenDelete: onOpenDeleteModal,
    setOfferId
  });

  const onRowClick = (row: IOffer) => {
    setOfferId(row.id);
    onOpenOfferDetailsModal();
  };

  const onChangeOffersPriority = (value: DragDropChangeValue) => {
    const { draggableId, toKeyForReorder, fromIndex, toIndex } = value;

    setOffers(
      moveElementInArray({
        array: offersList,
        fromIndex,
        toIndex,
        keyForReorder: "order"
      })
    );

    offersReorder.mutate({
      offerId: draggableId,
      newOrder: toKeyForReorder !== undefined ? toKeyForReorder : toIndex
    });
  };

  return (
    <>
      <ItemsTableDragDrop
        className={styles.banners_table}
        columns={columns}
        data={offersList}
        sorting={sorting}
        setSorting={setSorting}
        isLoading={isLoading}
        skeletonHeight={65}
        onRowClick={onRowClick}
        droppableId={"offersList"}
        keyForReorder={"order"}
        onChange={onChangeOffersPriority}
        isDragDisabled={isDragDisabled}
      />

      <If condition={isOpenOfferModal}>
        <CreateOfferModal
          offerId={offerId}
          isOpen={isOpenOfferModal}
          onClose={onCloseOfferModal}
        />
      </If>

      <If condition={isOpenDeleteModal}>
        <DeleteOfferModal
          offerId={offerId}
          isOpen
          onCloseParentModal={onCloseOfferDetailsModal}
          onClose={onCloseDeleteModal}
        />
      </If>

      <If condition={isOpenOfferDetailsModal}>
        <OfferDetailsModal
          isOpen
          onDelete={onOpenDeleteModal}
          onEdit={onOpenOfferModal}
          onClose={onCloseOfferDetailsModal}
          sharedData={offer}
          isLoadingData={isLoadingOffer}
          bannerType="Offer"
        />
      </If>
    </>
  );
};

export default OffersTable;
